/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { MEDIA_URL } from 'config/api';
import { hexToRGBA } from '@age-gateway/utils/theme-utils';

const defaultTheme = {
  '--background-color': '#fff',
  '--text-color': '#00321E',
  '--font-family-title': 'Montserrat, sans-serif',
  '--font-weight-title': '900',
  '--font-family-text': 'Montserrat, sans-serif',
  '--font-weight-text': '300',
  '--font-family-btn': 'Montserrat, sans-serif',
  '--font-weight-btn': '600',
  '--button-focus-color': 'rgba(0, 50, 30, 0.05)',
  '--button-border-color': 'rgba(0, 50, 30, 0.75)'
};

const getTheme = (theme: any) => {
  if (!theme || typeof theme === 'undefined') {
    return defaultTheme;
  }

  const customTheme = { ...defaultTheme };

  Object.entries(theme).forEach(([key, value]) => {
    if (!value || typeof value === 'undefined' || value.length < 1) {
      return;
    }

    // convert uppercase chars in camel case to hyphens
    let dashedKey = key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);

    if (key === 'textFont') {
      if (value.name) {
        customTheme['--font-family-text'] =
          value && `${value.name}, Montserrat, sans-serif`;
      }

      if (value.weight) {
        customTheme['--font-weight-text'] = value.weight;
      }
      return;
    }

    if (key === 'titleFont') {
      if (value.name) {
        customTheme['--font-family-title'] =
          value && `${value.name}, Montserrat, sans-serif`;
      }

      if (value.weight) {
        customTheme['--font-weight-title'] = value && value.weight;
      }
      return;
    }

    // for websites configured with the old (legacy) agegateway theme format
    // use the textFont family as the buttonFont family
    if (key === 'buttonFont') {
      if (value.name) {
        customTheme['--font-family-btn'] =
          value && `${value.name}, Montserrat, sans-serif`;
      } else if (theme?.textFont?.name) {
        customTheme[
          '--font-family-btn'
        ] = `${theme.textFont.name}, Montserrat, sans-serif`;
      }

      // for websites configured with the old (legacy) agegateway theme format
      // use the textFont weight as the buttonFont weight
      if (value.weight) {
        customTheme['--font-weight-btn'] = value && value.weight;
      } else if (theme?.textFont?.weight) {
        customTheme['--font-weight-btn'] = theme?.textFont?.weight;
      }
      return;
    }

    if (dashedKey === 'primary-color') {
      dashedKey = 'text-color';
      customTheme['--button-focus-color'] = hexToRGBA(value, 0.05);
      customTheme['--button-border-color'] = hexToRGBA(value, 0.75);
    }

    if (value && typeof value !== 'undefined' && value.length > 0) {
      const propertyKey = `--${dashedKey}`;

      customTheme[propertyKey] = value;
    }
  });

  return customTheme;
};

const getLogoURL = (logoUrl: string) => {
  if (!logoUrl || typeof logoUrl === 'undefined') {
    return null;
  }
  // Regular expression for a basic URL pattern
  const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
  // Test the input string against the regular expression
  const isFullUrl = urlPattern.test(logoUrl);
  // if the logoUrl is a complete url, return the original string
  if (isFullUrl) {
    return logoUrl;
  }

  // otherwise, compose the logo url with the MEDIA_URL const + logoUrl path
  const url = `${MEDIA_URL}${logoUrl}`;

  return url;
};

export { getLogoURL, getTheme };
